import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
  state.isAuthenticated = false;
};

const consultantsSlice = createSlice({
  name: "Consultant",
  initialState: {
    isLoading: false,

    consultant: {},
    consultantList: [],
    nearByConsultantList: [],
  },
  reducers: {
    
    // Consultant
    getConsultantsRequest: (state) => setLoading(state, true),
    getConsultantsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "consultantList"),
    getConsultantsFailure: (state) => setLoading(state, false),

    // Consultant Details
    getConsultantDetailsRequest: (state) => setLoading(state, true),
    getConsultantDetailsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "consultantDetails"),
    getConsultantDetailsFailure: (state) => setLoading(state, false),

    // NearByUsers
    getNearByUsersRequest: (state) => setLoading(state, true),
    getNearByUsersSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "nearByConsultantList"),
    getNearByUsersFailure: (state) => setLoading(state, false),

      // Delete supplier actions
      deleteConsultantRequest: (state) => setLoading(state, true),
      deleteConsultantSuccess: (state, action) => 
        setSuccessWithData(state, action.payload, "consultantList"),
      deleteConsultantFailure: (state) => setFailure(state),
  
  },
});

export const {
  getConsultantsRequest,
  getConsultantsSuccess,
  getConsultantsFailure,
  getConsultantDetailsRequest,
  getConsultantDetailsSuccess,
  getConsultantDetailsFailure,
  getNearByUsersRequest,
  getNearByUsersSuccess,
  getNearByUsersFailure,
  deleteConsultantRequest,
  deleteConsultantSuccess,
  deleteConsultantFailure,
} = consultantsSlice.actions;

export const consultantReducerSlice = consultantsSlice.reducer;
